import type { ReactNode } from 'react'

import { Button } from '../../../components/Button'
import { Callout } from '../../components/Callout'
import { errorMessage } from './errorMessage'

/** Loading and error states shared by every Transport settings section. Renders
 * nothing once the data is in, so the section shows its own content. */
export function SectionState({
  isPending,
  error,
  onRetry,
  what,
}: {
  isPending: boolean
  error: unknown
  onRetry: () => void
  what: string
}): ReactNode {
  if (isPending) {
    return (
      <p role="status" className="text-sm text-ink-3">
        Loading {what}…
      </p>
    )
  }
  if (error) {
    return (
      <Callout tone="warn">
        <span className="flex flex-wrap items-center gap-3">
          <span>
            Could not load {what}. {errorMessage(error)}
          </span>
          <Button kind="secondary" onClick={onRetry}>
            Try again
          </Button>
        </span>
      </Callout>
    )
  }
  return null
}
